export default {
  SET_QHSES: (state, payload) => state.qhses = payload,
}